module.exports = __webpack_public_path__ + "static/media/mobile_capy_page_area01_img_cn@2x.4777cbe0.png";